module.exports = __webpack_public_path__ + "static/media/customer-modern.a94b5742.png";